import VwHbsIslemtanimDTO from 'src/models/GenelTanimlar/VwHbsIslemtanimDTO';
import { ApiService } from 'src/services/core';

class VwHbsIslemtanimService extends ApiService<VwHbsIslemtanimDTO>{
    constructor() {
        super('VwHbsIslemtanimDTO');
    }
}

export default new VwHbsIslemtanimService();